import styled, { css } from 'styled-components'

export const ResourceSpan = styled.span(({ theme }) => {
  const { palette } = theme
  return css`
    color: ${palette.black};
  `
})
